@if (view$ | async; as view) {
    @if (consumptionAgents.length === 0) {
        <div class="alert alert-warning text-center m-3" role="alert">
            {{
                ('table_NO_DATA_FROM_SOURCE' | translate: 'online' : 'common')
                    .replace('{0}', 'monitoring_consumption_agents' | translate)
                    .replace('{1}', 'monitoring_create_consumption_agent' | translate)
            }}
        </div>
    } @else {
        <div class="table-responsive w-100">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        @for (header of columnHeaders; track $index) {
                            <th
                                app-sortable-table-header
                                [column]="header.column"
                                (sort)="
                                    onSort({column: header.column, direction: $event.direction})
                                "
                                [label]="
                                    header.label.key
                                        | translate: header.label.application : header.label.module
                                "></th>
                        }

                        <th class="last-col"></th>
                    </tr>
                    <tr [formGroup]="formGroupFilter">
                        @for (header of columnHeaders; track $index) {
                            <th class="align-top">
                                @if (header.formType === 'text') {
                                    <app-input-text-group
                                        [formControlName]="header.column"></app-input-text-group>
                                }
                                @if (header.formType === 'selectMultiple') {
                                    @switch (header.column) {
                                        @case ('meterCriteriaMismatch') {
                                            <app-input-dropdown-checkboxes
                                                [formControl]="
                                                    formGroupFilter.controls.meterCriteriaMismatch
                                                ">
                                            </app-input-dropdown-checkboxes>
                                        }
                                        @case ('meterSuperTypeNo') {
                                            <app-input-dropdown-checkboxes
                                                [formControl]="
                                                    formGroupFilter.controls.meterSuperTypeNo
                                                ">
                                            </app-input-dropdown-checkboxes>
                                        }
                                        @case ('consumptionToMonitor') {
                                            <app-input-dropdown-checkboxes
                                                [formControl]="
                                                    formGroupFilter.controls.consumptionToMonitor
                                                ">
                                            </app-input-dropdown-checkboxes>
                                        }
                                        @case ('schedule') {
                                            <app-input-dropdown-checkboxes
                                                [formControl]="formGroupFilter.controls.schedule">
                                            </app-input-dropdown-checkboxes>
                                        }
                                        @case ('sendBlank') {
                                            <app-input-dropdown-checkboxes
                                                [formControl]="formGroupFilter.controls.sendBlank">
                                            </app-input-dropdown-checkboxes>
                                        }
                                        @case ('showConsumptionForMeters') {
                                            <app-input-dropdown-checkboxes
                                                [formControl]="
                                                    formGroupFilter.controls
                                                        .showConsumptionForMeters
                                                ">
                                            </app-input-dropdown-checkboxes>
                                        }
                                    }
                                }
                            </th>
                        }
                        <th class="last-col"></th>
                    </tr>
                </thead>
                <tbody class="text-nowrap">
                    @for (consumptionAgent of view.consumptionAgents; track $index) {
                        <tr>
                            <td class="text-center">
                                @if (consumptionAgent.meterCriteriaMismatch) {
                                    <i class="bi bi-exclamation-circle-fill text-warning"></i>
                                } @else {
                                    <i class="bi bi-check-circle-fill text-success"></i>
                                }
                            </td>
                            <td>
                                {{ consumptionAgent.agentName }}
                            </td>
                            <td>
                                @if (consumptionAgent.meterSuperTypeNo != null) {
                                    {{
                                        'mappers_meterType.' + consumptionAgent.meterSuperTypeNo
                                            | translate: 'online' : 'common'
                                    }}
                                }
                            </td>
                            <td>
                                {{ consumptionAgent.usageAndUnit }}
                            </td>
                            <td>
                                {{ consumptionAgent.dayCount }}
                            </td>
                            <td>
                                {{ consumptionAgent.consumptionToMonitor }}
                            </td>
                            <td>
                                {{ consumptionAgent.investigation }}
                            </td>
                            <td>
                                {{
                                    'reportagent_' + consumptionAgent.schedule
                                        | translate: 'online' : 'reportagent'
                                }}
                            </td>
                            <td>
                                {{ consumptionAgent.recipients }}
                            </td>
                            <td>
                                <app-true-false
                                    [value]="consumptionAgent.sendBlank"></app-true-false>
                            </td>
                            <td>
                                <app-true-false
                                    [value]="
                                        consumptionAgent.showConsumptionForMeters
                                    "></app-true-false>
                            </td>
                            <td class="last-col">
                                <div ngbDropdown placement="bottom-right" container="body">
                                    <button
                                        class="btn btn-link btn-sm p-0"
                                        id="dropdownMeterActions"
                                        ngbDropdownToggle
                                        style="float: right">
                                        <i class="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <div ngbDropdownMenu>
                                        <button
                                            ngbDropdownItem
                                            (click)="
                                                editAgent(
                                                    consumptionAgent.reportId,
                                                    consumptionAgent.agentName
                                                )
                                            ">
                                            {{ 'common_Edit' | translate }}
                                        </button>
                                        <button
                                            ngbDropdownItem
                                            (click)="duplicateAgent(consumptionAgent.reportId)">
                                            {{ 'monitoring_duplicate' | translate }}
                                        </button>
                                        <button
                                            ngbDropdownItem
                                            (click)="navigateToResults(consumptionAgent)">
                                            {{ 'monitoring_run_agent' | translate }}
                                        </button>
                                        <button
                                            ngbDropdownItem
                                            (click)="deleteAgent(consumptionAgent)">
                                            {{
                                                'modals_deleteEmailModal.actions.deleteEmail'
                                                    | translate: 'online' : 'systems'
                                            }}
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="20" class="text-center">
                                {{ 'table_noResults' | translate: 'online' : 'common' }}
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="text-center">
            <app-pagination
                [collectionSize]="view.collectionSize"
                [page]="view.page"
                (pageChange)="setPage($event)"
                (pageSizeChange)="setPageSize($event)"></app-pagination>
        </div>
    }
} @else {
    <app-load />
}
